import React from 'react';
import { localize } from '../Util/L10n';
import { TwoColumns } from './TwoColumns';
import { withRouter } from 'react-router-dom';
import Link from '../Util/Paths';

class Start extends React.Component {
  render() {
    const { imageUrl, descriptionHtml, match } = this.props;

    return (
      <div className="start">
        <TwoColumns
          left={<img src={imageUrl} className="img-fluid" />}
          right={
            <React.Fragment>
              <h2 className="start__title">{localize('title')}</h2>
              <div
                dangerouslySetInnerHTML={{
                  __html: descriptionHtml,
                }}
              />
              <Link
                className="btn btn-primary"
                to="semester"
                params={{
                  studyplan: match.params.studyplan,
                  semester: 1,
                }}
              >
                {localize('startPageStartButton')}
              </Link>
            </React.Fragment>
          }
        />
      </div>
    );
  }
}

export default withRouter(Start);
